import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe, getCredits } from '../services/api';


const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [credits, setCredits] = useState(null); // { available_credits, is_pro, daily_usage, daily_limit }

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      getMe()
        .then(r => setUser(r.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  // Fetch credit balance whenever user changes
  useEffect(() => {
    if (user) {
      fetchCredits();
    } else {
      setCredits(null);
    }
  }, [user]);

  const fetchCredits = useCallback(async () => {
    try {
      const res = await getCredits();
      setCredits(res.data);
    } catch {
      setCredits(null);
    }
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('token', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setCredits(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, credits, loginUser, logout, fetchCredits }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
